import { jsx as _jsx } from "react/jsx-runtime";
import { ThemeColorVariable } from '@caspeco/casper-ui-library.base-ui.theme';
import { Skeleton as ChakraSkeleton } from '@chakra-ui/react';
/**
 * Used to display the loading state of some component.
 *
 * @see Docs https://bit.cloud/caspeco/casper-ui-library/components/skelton
 */
export function Skeleton({ startColor = ThemeColorVariable.BackgroundDisabled, endColor = ThemeColorVariable.OnBackgroundBorder, children, ...props }) {
    return (_jsx(ChakraSkeleton, { startColor: startColor, endColor: endColor, ...props, children: children }));
}
//# sourceMappingURL=skeleton.js.map